import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ListOfRepairService from "../services/ListOfRepairService";

export const fetchCalendarRepairs = createAsyncThunk(
  "calendar/fetchCalendarRepairs",
  async ({ companyName, projectName, modelName }, { rejectWithValue }) => {
    try {
      const data = await ListOfRepairService.getCalendar(
        companyName,
        projectName,
        modelName,
      );
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

const calendarSlice = createSlice({
  name: "calendar",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {
    setCalendarData(state, action) {
      state.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCalendarRepairs.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCalendarRepairs.fulfilled, (state) => {
        state.loading = false;
        // ไม่ set state.data ที่นี่แล้ว
      })
      .addCase(fetchCalendarRepairs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setCalendarData } = calendarSlice.actions;
export default calendarSlice.reducer;
